import React, { Component } from 'react';
import { connect } from 'react-redux';
import './style-custom.scss';
import withRouter from '../../../components/withRouter';
import windowSize from '../../../components/windowSize';
import Auth from '../../../../models/Auth';
import * as actionTypes from './../../../../store/actions';
import { withTranslation } from 'react-i18next';
import { Fragment } from 'react';
import MenuItem from './MenuItem';
import { t } from 'i18next';
import { FILTER_PERMISSION } from '../../../../constants/client-permission';

const pageCode = 'SideMenu';

export const SIDE_MENU_ITEMS = () => [
    {
        title: t(`SideMenu.Home`),
        name: 'Home',
        path: '/dashboard/home',
        icon: 'home-icon',
    },
    {
        title: t(`SideMenu.DashBoard`),
        name: 'Dashboard',
        path: '/dashboard/basic',
        icon: 'ds-icon',
    },
    {
        title: t(`SideMenu.ServiceRequest`),
        name: 'Service Request',
        path: '/dashboard/service-request',
        icon: 'file-icon',
    },
    {
        title: t(`SideMenu.Document`),
        name: 'Document',
        path: '/dashboard/documents',
        icon: 'doc-icon',
    },
    {
        title: t(`SideMenu.ImportRequest`),
        name: 'Import Request',
        path: '/dashboard/import-request',
        icon: 'file-icon',
    },
    {
        id: 'divider',
        clazz: 'nav-item-divider',
    },
    {
        title: t(`SideMenu.Support`),
        name: 'Support',
        path: '/dashboard/support',
        icon: 'ass-icon',
    },
    {
        title: t(`SideMenu.Setting`),
        name: 'Setting',
        path: '/dashboard/setting',
        icon: 'gear-icon',
    },
]

const LAST_ITEMS = ['Support', 'Setting']

class Navigation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            redirect: false,
        }
    }
    resize = () => { }

    componentDidMount() {
        this.resize();
        window.addEventListener('resize', this.resize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize)
    }
    gotoHome = () => {
        console.log('Go to Home page')
        this.props.navigate(`/dashboard/home${this.props.location.search}`)
    }

    convertMenuItems(items, defaultIcon = 'fa-list-alt') {
        if (!(items && items.length)) {
            return []
        }
        return items.map((item, i) => {
            const id = item.id || (i + 1)
            const baseUrl = (item.path || item.url || '')
            const pathUrl = `${baseUrl}${window.location.search}`
            let mitem = {
                id,
                name: item.title || item.name,
                icon: `nav-icon fas ${item.icon || defaultIcon}`,
                baseUrl: baseUrl,
                path: pathUrl,
                children: [],
                clazz: (item.clazz || ''),
                open: item.open
            }
            if (item.children && item.children.length) {
                mitem.children = this.convertMenuItems(item.children, defaultIcon)
            }
            return mitem
        })
    }

    _getMenus() {
        if ((Auth.token && !Auth.isTokenExpired)) {
            let menuItems = FILTER_PERMISSION(SIDE_MENU_ITEMS(), Auth.hasRightView, '')
            this._fixMenus(menuItems)
            // menuItems = this.permissionFilter(menuItems)
            menuItems = this.convertMenuItems(menuItems)
            return menuItems
        }
        return []
    }
    _fixMenus(menuItems) {
        let i1 = menuItems.findIndex(a => a.id === 'divider')
        if (i1 >= 0) {
            let i2 = menuItems.findIndex((a, i) => i !== i1 && a.id === 'divider')
            if (i2 === i1 + 1) {
                menuItems.splice(i2, 1)
            }
        }
        let i2 = menuItems.findIndex(a => a.id === 'divider')
        if (menuItems.length && (i2 === menuItems.length - 1)) {
            menuItems.splice(i2, 1)
        }

        let lastIdx = menuItems.findIndex(a => LAST_ITEMS.includes(a.name))
        if (lastIdx > 0) {
            let i = (lastIdx - 1)
            let item = menuItems[i]
            while (item && item.id === 'divider') {
                item = menuItems[--i]
            }
            if (item) {
                if (item.clazz) {
                    item.clazz = `${item.clazz} nav-item-spacing`
                } else {
                    item.clazz = `nav-item-spacing`
                }
            }
        }
    }

    render() {
        let menuItems = this._getMenus()
        return (
            <Fragment>
                {/* Main Sidebar Container */}
                <aside className="main-sidebar sidebar-light-primary">
                    {/* Brand Logo */}
                    {/* <div className="brand-link">
                        <span className='inline-block left' data-widget="pushmenu" href="#" role="button"><i className="fas fa-stream" /></span>
                        <a className='inline-block left' href={DEMO.BLANK_LINK}>
                            <img src="/theme/img/Logo.png" alt="Logo" className="brand-image" style={{ opacity: '.8' }} />
                        </a>
                        <div className='clearfix'></div>
                    </div> */}
                    {/* Sidebar */}
                    <div className="sidebar" >
                        {/* Sidebar user panel (optional) */}
                        <div className="user-panel d-flex">
                            <div className="image" style={{ display: 'none' }}>
                                <img src="/theme/img/user.svg" className="img-circle elevation-2" alt="User Image" />
                            </div>
                            <div className="info">
                                {t(`${pageCode}.Welcome`)}
                                <a href="javascript:void(0)" className="d-block">{Auth.fullName || Auth.username || ''}</a>
                            </div>
                        </div>
                        {/* Sidebar Menu */}
                        <nav className="mt-2 mb-2" >
                            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                                {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
                                {menuItems && menuItems.map((item, i) => (
                                    <>
                                        <MenuItem
                                            key={(item.id || i) + item.name + item.path}
                                            menuItem={item} />
                                    </>
                                ))}
                            </ul>
                        </nav >
                        {/* /.sidebar-menu */}
                    </div >
                    {/* /.sidebar */}
                </aside >
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        layout: state.reducer.layout,
        preLayout: state.reducer.preLayout,
        collapseMenu: state.reducer.collapseMenu,
        layoutType: state.reducer.layoutType,
        navBackColor: state.reducer.navBackColor,
        navBackImage: state.reducer.navBackImage,
        navIconColor: state.reducer.navIconColor,
        navBrandColor: state.reducer.navBrandColor,
        layout6Background: state.reducer.layout6Background,
        layout6BackSize: state.reducer.layout6BackSize,
        rtlLayout: state.reducer.rtlLayout,
        navFixedLayout: state.reducer.navFixedLayout,
        boxLayout: state.reducer.boxLayout,
        navDropdownIcon: state.reducer.navDropdownIcon,
        navListIcon: state.reducer.navListIcon,
        navActiveListColor: state.reducer.navActiveListColor,
        navListTitleColor: state.reducer.navListTitleColor,
        navListTitleHide: state.reducer.navListTitleHide,
        selectedPortalLogo: state.portal.selectedPortalLogo,
        programData: state.allRequest.programData

    }

};

const mapDispatchToProps = dispatch => {
    return {
        onToggleNavigation: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
        onChangeLayout: (layout) => dispatch({ type: actionTypes.CHANGE_LAYOUT, layout: layout }),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(windowSize(withTranslation()(Navigation))));
